import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IEvent, IUserNotification } from '../../types';

interface NotificationState {
  limitCount: number;
  loading: boolean;
  error: string | null;
  totalCount: number;
  notifications: IUserNotification[];
}

const initialState: NotificationState = {
  limitCount: 10,
  loading: false,
  error: null,
  totalCount: 0,
  notifications: [],
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    updateLimitCount: (state, action: PayloadAction<number>) => {
      state.limitCount = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    updateNotifications: (state, action: PayloadAction<IUserNotification[]>) => {
      state.notifications = action.payload;
    },
    setTotalCount: (state, action: PayloadAction<number>) => {
      state.totalCount = action.payload;
    }
  },
});
export const { updateLimitCount, setLoading, updateNotifications, setTotalCount } = notificationSlice.actions;
export default notificationSlice.reducer;